<template>
    <div class="edit-bottom-bar">
        <RoundButton class="draft-save-btn" :text="draftLabel" :icon="draftIcon" @btnClick="draftSave" />
        <div class="operate-btn-box">
            <RoundButton class="cancel-btn" :text="cancelLabel" @btnClick="cancelClick" />
            <RoundButton
                class="online-btn"
                :class="{ 'btn-disabled': isDisableOnline }"
                :text="onlineLabel"
                :icon="onlineIcon"
                @btnClick="onlineClick"
            />
            <RoundButton
                class="online-btn"
                v-show="isShowOffline"
                :class="{ 'btn-disabled': isDisableOnline }"
                :text="offlineLabel"
                :icon="offlineIcon"
                @btnClick="offlineClick"
            />
        </div>
    </div>
</template>

<script>
import RoundButton from "@/views/zhiji/bComponents/buttons/RoundButton";
import { quesSaveType } from "@/views/zhiji/js/common/constants.js";

export default {
    name: "BottomBar",
    components: {
        RoundButton
    },
    data() {
        return {
            draftUrl: "",
            onlineUrl: "",
            offlineUrl: ""
        };
    },
    computed: {
        draftIcon() {
            return this.getStorePorp("isUpdating") === "sending" ? this.draftUrl : "";
        },
        onlineIcon() {
            if (this.getStorePorp("isUpdating") === "success" && this.onlineUrl) {
                this.$nextTick(() => {
                    this.$emit("saveClick");
                    this.showSuccessTip(this.$t("zhiji.knowlege.onlineSucTip"));
                });
            }

            return this.getStorePorp("isUpdating") === "sending" ? this.onlineUrl : "";
        },
        offlineIcon() {
            if (this.getStorePorp("isUpdating") === "success" && this.offlineUrl) {
                this.$nextTick(() => {
                    this.$emit("saveClick");
                    this.showSuccessTip(this.$t("zhiji.knowlege.offlineSucTip"));
                });
            }
            return this.getStorePorp("isUpdating") === "sending" ? this.offlineUrl : "";
        },
        draftLabel() {
            return this.$t("zhiji.knowlege.quesEditModal.saveDraft");
        },
        cancelLabel() {
            return this.$t("zhiji.common.cancel");
        },
        onlineLabel() {
            return this.$t("zhiji.knowlege.quesEditModal.onlineBtn");
        },
        offlineLabel() {
            return this.$t("zhiji.knowlege.quesEditModal.offlineBtn");
        },
        isDisableOnline() {
            const currentLang = this.getStorePorp("currentSynonym");
            const langs = this.getStorePorp("synonymQuestions");
            const defaultLangItem = this.zhiji.genItemSearchHandler("lang")(langs, this.defaultLang);
            if (!currentLang || (!this.isDefaultLang(currentLang) && defaultLangItem.status != "online")) {
                return true;
            }
            return false;
        },
        defaultLang() {
            const defaultLang = this.$store.state.zhiji.gameState.defaultLang;
            return defaultLang ? defaultLang : "en";
        },
        // 是否显示下线按钮
        isShowOffline() {
            const currentLang = this.getStorePorp("currentSynonym");
            const langs = this.getStorePorp("synonymQuestions");
            const defaultLangItem = this.zhiji.genItemSearchHandler("lang")(langs, currentLang);
            return defaultLangItem && defaultLangItem.status === "online" ? true : false;
        }
    },
    methods: {
        getStorePorp(propName) {
            return this.$store.state.zhiji.questionEdit[propName];
        },
        draftSave() {
            this.onlineUrl = "";
            this.offlineUrl = "";
            this.draftUrl = "url(" + this.zhiji.staticPath() + "loading-black.gif) 0 0/cover";

            this.$store.dispatch("zhiji/saveQuesEditor", {
                saveType: quesSaveType.DRAFT
            });
        },
        cancelClick() {
            this.$emit("close");
        },
        onlineClick() {
            if (this.isDisableOnline) {
                return;
            }
            this.draftUrl = "";
            this.offlineUrl = "";
            this.onlineUrl = "url(" + this.zhiji.staticPath() + "loading-whrite.gif) 0 0/cover";

            this.$store.dispatch("zhiji/saveQuesEditor", {
                saveType: quesSaveType.SUBMIT
            });
        },
        offlineClick() {
            if (this.isDisableOnline) {
                return;
            }
            this.draftUrl = "";
            this.onlineUrl = "";
            this.offlineUrl = "url(" + this.zhiji.staticPath() + "loading-whrite.gif) 0 0/cover";

            this.$store.dispatch("zhiji/saveQuesEditor", {
                saveType: quesSaveType.OFFLINE
            });
        },
        isDefaultLang(lang) {
            return this.defaultLang == lang;
        },
        showSuccessTip(message) {
            this.$message({
                message: message,
                center: true,
                duration: 2000,
                type: "success"
            });
        }
    }
};
</script>

<style lang="less" scoped>
.edit-bottom-bar {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 16px 8px 16px 24px;
    border-top: 1px solid #d9e4ef;
    background: #fafbfd;

    .operate-btn-box {
        margin-left: 150px;
    }

    .draft-save-btn,
    .cancel-btn {
        border: solid 1px #d8e4f0 !important;
        color: #41475e !important;
        background: #fff !important;
        box-shadow: none;
        min-width: 96px;
        padding: 0 24px;
        box-sizing: border-box;
        line-height: 30px;
        &:hover {
            color: #2ec2ff !important;
        }
    }

    .cancel-btn,
    .online-btn {
        width: 96px;
        box-sizing: border-box;
        line-height: 32px;
    }

    .btn-disabled {
        background: #c9c9c9 !important;
        color: #f2f2f2 !important;
        cursor: default;
    }
}
</style>
